module.exports = __webpack_public_path__ + "8db85a32d69e29e146c9bd3a9e98e23f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/loading.gif
// module id = 193
// module chunks = 0